import type {AfriexCountry} from '@/types';
import {mapCountryCodeToFlags} from '@/utils/countries';
import {capitalizeWords} from '@/utils/dashboard';
import * as formatDate from '@/utils/date';

import type {AfriexProcessorTransaction} from './types';

export const getProcessorTxFieldsToDisplay = (
  data: AfriexProcessorTransaction,
  countries: AfriexCountry[],
) => {
  const country = mapCountryCodeToFlags(countries)[data.country];
  return [
    {
      Type: capitalizeWords(data.type?.replace(/_/g, ' ')),
    },
    {'Processor Transaction ID': data.processorTransactionId},
    {
      'Initiated Amount': `${data.amount} ${data.asset}`,
    },
    {
      Country: (
        <>
          {data.country} {country}
        </>
      ),
    },
    {
      'Date Initiated': formatDate.dateTimeInTimeZone(
        data.createdAt?.toString(),
      ),
    },
    {Processor: data.processor},
    {Status: data.status},
  ];
};
